import { lazy, Suspense, useContext } from 'react'
import { WalletReadyContext } from '@/lib/walletContext'

const ColonyBannerEditorInnerLazy = lazy(() => import('@/components/ColonyBannerEditorInner'))

export default function ColonyBannerEditor({
  currentBanner,
  onPublished,
}: {
  currentBanner?: string
  onPublished?: (banner: string) => void
}) {
  const ready = useContext(WalletReadyContext)
  if (!ready)
    return null

  return (
    <Suspense fallback={null}>
      <ColonyBannerEditorInnerLazy currentBanner={currentBanner} onPublished={onPublished} />
    </Suspense>
  )
}
